import { render, staticRenderFns } from "./VSTHeader.vue?vue&type=template&id=049031ee&scoped=true"
import script from "./VSTHeader.vue?vue&type=script&lang=js"
export * from "./VSTHeader.vue?vue&type=script&lang=js"
import style0 from "./VSTHeader.vue?vue&type=style&index=0&id=049031ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049031ee",
  null
  
)

export default component.exports